import { api } from '@/api'
import UploadAvatar from '@/components/Button/UploadAvatar'
import { useCurrentUser } from '@/hooks'
import { userIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import style from '../styles/profile.module.scss'

const AvatarEditor = (): React.ReactElement => {
  const [isSend, setSend] = useState(false)
  const { currentUser, reRoadUser, isLoaded } = useCurrentUser()

  const handleChange = (e): void => {
    setSend(true)
    api
      .setAvatarUser({
        avatar: e.target.files[0]
      })
      .then(() => {
        setSend(false)
        reRoadUser()
      })
      .catch(() => {
        setSend(false)
      })
  }

  return (
    <div className={style.avatar_wrap}>
      {isLoaded
        ? (
          <>
            {currentUser?.personal_photo !== null
              ? (
                <img
                  src={currentUser?.personal_photo}
                  width='210px'
                  height='210px'
                  alt='Аватар'
                  className={style.avatar}
                />
                )
              : (
                <div className={style.avatar__empty_wrap}>
                  <GxIcon src={userIcon} className={style.avatar__empty} />
                </div>
                )}
            <UploadAvatar
              disabled={isSend}
              onChange={handleChange}
              className={style.avatar_upload}
            />
          </>
          )
        : null}
    </div>
  )
}

export { AvatarEditor }
